import { render, staticRenderFns } from "./218.vue?vue&type=template&id=55a8372d&scoped=true&"
var script = {}
import style0 from "./218.vue?vue&type=style&index=0&id=55a8372d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a8372d",
  null
  
)

export default component.exports